import p from '../../theme/palette';

const style = {
  uploadLabelError: {
    display: 'block',
    color: p.error,
    background: p.errorBg,
    border: '1px solid ' + p.error,
    padding: '12px 16px',
    fontSize: 13,
    borderRadius: 8,
    margin: '0 0 16px 0',
    textAlign: 'center',
  },
  cropper: {
    minHeight: 200,
    maxHeight: 400,
    minWidth: 200,
  },
};

export default style;
